/// <reference path="../../_ext/Editors/BOMEditorDialog.ts" />
namespace TabAurous.Purchase {
    @Serenity.Decorators.registerClass()
    export class QuotationBOMDialog extends _Ext.BOMEditorDialog<QuotationBOMRow> { 
        protected getLocalTextPrefix() { return QuotationBOMRow.localTextPrefix; } 
        protected get_ExtDialogOptions() {
            let opt = super.get_ExtDialogOptions();
            opt.AutoFitContentArea = false;
            opt.ShowApplyButton = false;
            return opt;
        }


        constructor() {
            super();
            q.setTextRightAlign(this.form.Pieces);
            q.setTextRightAlign(this.form.Weight);
            q.setTextRightAlign(this.form.PointerWeight);
            q.setTextRightAlign(this.form.BomAmount);
            q.setTextRightAlign(this.form.BomRate);
            q.setTextRightAlign(this.form.Purity);
            q.setTextRightAlign(this.form.Purity);

            // Module Configuration
            this.UseKaratWiseRate = q.ToBool(GetConfigValue(1014)); 

            this.form.BomRate.changeSelect2(e => {
                var calcon = this.form.CalcOnId.value;
                if (calcon == "4" || calcon == "5")
                    if (this.form.ItemTypeId.value == 104) {
                        if (this.UseKaratWiseRate == true)
                            this.form.BomAmount.value = this.form.BomRate.value * this.form.Weight.value || 0;
                        else
                            this.form.BomAmount.value = this.form.BomRate.value * this.form.Weight.value * this.form.Purity.value || 0;
                    }
                    else {
                        this.form.BomAmount.value = this.form.BomRate.value * this.form.Weight.value;
                    }
                if (calcon == "3")
                    this.form.BomAmount.value = this.form.BomRate.value * this.form.Pieces.value;

                this.form.CCBomAmount.value = this.form.BomAmount.value * this.ExchangeRate;

            });

            this.form.BOMProductId.changeSelect2(e => {
                var ItemID = Q.toId(this.form.ItemTypeId.value);
                if (ItemID == null) {
                    Q.notifyWarning("Select Item Type")
                    this.form.BOMProductId.value = "";
                    this.form.ItemTypeId.element.attr("tabindex", 1);
                }
                else {

                    var productID = Q.toId(this.form.BOMProductId.value);
                    

                    var Component: OMS.RawMaterialMasterRow;

                    OMS.RawMaterialMasterService.Retrieve({ EntityId: productID }, response => Component = response.Entity, { async: false });

                    this.form.ProductCode.value = Component.ProductCode;

                    this.form.Weight.value = 0;
                    this.form.Pieces.value = 0;

                    if (Component != null) {
                        this.IsConfigurable = Component.IsConfigurable;
                        this.form.CategoryId.value = Component.CategoryId.toString();
                        this.form.SubCategoryId.value = Component.SubCategoryId.toString();
                        this.form.ProductTypeId.value = Component.ProductTypeId.toString();
                        this.form.ItemType.value = Component.ItemType;
                        this.entity.CostMethodId = Component.CostMethodId;
                        this.form.CalcOnId.value = Component.CalcOnId.toString();
                        if (this.form.ItemTypeId.value == 104) {
                            var std = Component.Purity;
                            this.form.Purity.value = std;
                            this.form.MetalColorId.value = Component.MetalColorId.toString();
                            this.form.KaratId.value = Component.KaratId.toString();
                            this.form.ItemType.value = Component.ItemType;
                        }

                        if (this.form.ItemTypeId.value == 105) {
                            this.form.ShapeId.value = Component.ShapeId.toString();
                            this.form.StoneColorId.value = Component.StoneColorId.toString();
                            this.form.QualityId.value = Component.QualityId.toString();
                            this.form.ItemType.value = Component.ItemType;
                        }
                        ItemFieldHelper.PurchaseBOMFields(this);
                        this.GetRate();
                    }
                }

            });

            this.form.Pieces.changeSelect2(e => {
                if (this.form.CalcOnId.value == "3") {
                    this.form.BomAmount.value = this.form.Pieces.value * this.form.BomRate.value;
                    this.form.CCBomAmount.value = this.form.BomAmount.value * this.ExchangeRate;
                }
            });

            this.form.Weight.changeSelect2(e => {
                if (this.form.CalcOnId.value == "4" || this.form.CalcOnId.value == "5")
                    if (this.form.Purity.value > 0) {
                        this.form.PureWeight.value = this.form.Weight.value * this.form.Purity.value;
                        this.form.BomAmount.value = this.UseKaratWiseRate ? this.form.BomRate.value * this.form.Weight.value : this.form.BomRate.value * this.form.PureWeight.value;
                    }
                    else {
                        this.form.BomAmount.value = this.form.Weight.value * this.form.BomRate.value
                    }
                this.form.CCBomAmount.value = this.form.BomAmount.value * this.ExchangeRate;

            });

            this.form.ProductTypeId.changeSelect2(e => {
                if (this.form.ProductTypeId.value != "") {
                    this.form.BOMProductId.cascadeField = "ProductTypeId";
                    this.form.BOMProductId.cascadeValue = this.form.ProductTypeId.value;

                    this.form.ItemTypeId.value = OMS.ProductTypeRow.getLookup().itemById[parseInt(this.form.ProductTypeId.value)].ItemTypeId;
                    this.form.CategoryId.ItemTypeId = this.form.ItemTypeId.value;
                    this.form.CategoryId.value = "";
                    this.form.CategoryId.updateItems();
                    this.form.SubCategoryId.value = "";
                    ItemFieldHelper.PurchaseBOMFields(this);
                }
            });


            this.form.CategoryId.changeSelect2(e => {
                this.form.BOMAttributeId.value = "0";
                this.form.SubCategoryId.CategoryId = parseInt(this.form.CategoryId.value);
                this.form.SubCategoryId.updateItems();
                ItemFieldHelper.PurchaseBOMFields(this);
            })

            //this.form.GrossWeight.changeSelect2(e => {
            //    var wt = (this.parentEditor.parentDialog as ApprovalInItemsDialog).form.Weight.value;
            //    this.form.Weight.value = this.form.GrossWeight.value - wt;
            //    if (this.form.CalcOnId.value == "4" || this.form.CalcOnId.value == "5")
            //        if (this.form.Purity.value > 0) {
            //            this.form.PureWeight.value = this.form.Weight.value * this.form.Purity.value;
            //            this.form.BomAmount.value = this.UseKaratWiseRate == 'True' ? this.form.BomRate.value * this.form.Weight.value : this.form.BomRate.value * this.form.PureWeight.value;
            //        }
            //        else {
            //            this.form.BomAmount.value = this.form.Weight.value * this.form.BomRate.value
            //        }
            //})

            // Validate Purity
            this.form.Purity.change(e => {
                var AttID = Q.toId(this.form.BOMAttributeId.value);
                if (AttID != null) {
                    var productID = this.form.BOMProductId.value;

                    let prddetails;
                    OMS.ProductMasterService.Retrieve({
                        EntityId: productID
                    }, response => {
                        prddetails = response.Entity
                    }, { async: false });
                    var max = prddetails.MaxPurity;
                    var min = prddetails.MinPurity;
                    var std = prddetails.StdPurity; var current = this.form.Purity.value;
                    if (current < min || current > max) {
                        Q.alert("Enter Purity between  " + min.toString() + "  to  " + max.toString());
                        this.form.Purity.value = std;
                    }
                }
                this.GetRate();

            });

            this.form.KaratId.changeSelect2(e => {
                this.form.BOMAttributeId.value = "0";
                var KaratId = Q.toId(this.form.KaratId.value);
                var purity: OMS.AttributeMasterRow;
                OMS.AttributeMasterService.Retrieve({ EntityId: parseInt(KaratId) }, response => {
                    purity = response.Entity
                }, { async: false });
                var min = purity.MinPurity;
                var max = purity.MaxPurity;
                var std = purity.StdPurity;
                this.form.Purity.value = std;

                this.GetRate();
            });

            this.form.ItemTypeId.changeSelect2(e => {
                this.form.BOMAttributeId.value = "0";
                ItemFieldHelper.PurchaseBOMFields(this);
            });

            this.form.StoneSizeId.changeSelect2(e => {
                this.form.BOMAttributeId.value = "0";
                this.GetRate();
            });

            this.form.ShapeId.changeSelect2(e => {
                this.form.BOMAttributeId.value = "0";
                this.GetRate();
            });

            this.form.SieveId.changeSelect2(e => {
                this.form.BOMAttributeId.value = "0";
                this.GetRate();
            });

            this.form.QualityId.changeSelect2(e => {
                this.form.BOMAttributeId.value = "0";
                this.GetRate();
            });

            this.form.StoneColorId.changeSelect2(e => {
                this.form.BOMAttributeId.value = "0";
                this.GetRate();
            });
        }

        afterLoadEntity() {
            super.afterLoadEntity();

            this.BOMMaster = (this.parentEditor.parentDialog as QuotationItemsDialog);
            this.RateListId = this.BOMMaster.RateListId;
            this.LaborListId = this.BOMMaster.LaborListId;
            this.StoneMarkup = this.BOMMaster.StoneMarkup;
            this.StoneDiscount = this.BOMMaster.StoneDiscount;
            this.ExchangeRate = this.BOMMaster.ExchangeRate;
            this.TransDate = this.BOMMaster.TransDate;

            var Component: OMS.RawMaterialMasterRow;
            if (!Q.isEmptyOrNull(this.form.BOMProductId.value)) {
                OMS.RawMaterialMasterService.Retrieve({ EntityId: this.form.BOMProductId.value }, response => Component = response.Entity, { async: false });
                this.IsConfigurable = Component.IsConfigurable;
            }

            ItemFieldHelper.PurchaseBOMFields(this);
            if (this.BOMMaster.isReadOnly == true) {
                this.setReadOnly(true);
            }
        }
    }
}